import { Component, Input, Output, EventEmitter } from '@angular/core';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-new-files',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './new-files.component.html',
  styleUrl: './new-files.component.css'
})
export class NewFilesComponent {
  @Input() files: File[] = []; // Input for new files
  @Output() removeNewFile = new EventEmitter<File>(); // Emit when a file is removed

  constructor(
    private getFileIconService: GetFileIconUtilityService
  ) { }

  // Handle file removal
  onRemove(file: File) {
    this.removeNewFile.emit(file);
  }

  getFileIcon(mimeType: string): string {
    return this.getFileIconService.getFileTypeFromMime(mimeType);
  }

}
